// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2fVkP","info":"PatientInfo_info__2Vp3C"};